import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.01988 17.0761C3.70167 16.811 3.65868 16.3381 3.92385 16.0198L11.4239 7.01984C11.5663 6.84885 11.7774 6.74998 12 6.74998C12.2226 6.74998 12.4337 6.84885 12.5762 7.01984L20.0762 16.0198C20.3414 16.3381 20.2984 16.811 19.9802 17.0761C19.662 17.3413 19.189 17.2983 18.9239 16.9801L12 8.67152L5.07618 16.9801C4.81101 17.2983 4.33809 17.3413 4.01988 17.0761Z"
})), "IconChevronUp");